import { Link } from '@tanstack/react-router'
import styled from 'styled-components'
import { IconV2 } from 'ui/components/Icon'

export const MenuItemIcon = styled(IconV2)`
  color: var(--theme-colors-global-grey-grey700);
`

export const MenuItem = styled(Link)`
  font: var(--theme-typography-bodyL-semiBold);
  width: 224px;
  color: var(--theme-colors-global-general-secondary);
  text-decoration: none;
  padding: 0 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    text-decoration: none;
    color: var(--theme-colors-global-general-secondary) !important;
    background: var(--theme-colors-global-grey-grey100);
  }
`
